<template>
  <div class="kiw-index-toolbar">
    <AppSearchInput
      class="kiw-index-toolbar__search mr-2"
      search-placeholder="Wyszukaj"
      @search="filterKIW({ query: $event })"
    />

    <v-select
      :value="selectedFilters.purpose"
      :items="purposesFiltersLabels"
      item-value="id"
      item-text="label"
      placeholder="Cel przekazania materiału"
      v-bind="props.select"
      class="mr-2 width-220"
      @input="selectToggleFilter({ purpose: $event })"
    />

    <v-select
      :value="selectedFilters.department"
      :items="filtersOptions.departments"
      item-value="id"
      item-text="name"
      placeholder="Oddział"
      v-bind="props.select"
      class="mr-2 width-140"
      @input="selectToggleFilter({ department: $event })"
    >
      <template #selection="{ item }">
        {{ item.shortcut }}
      </template>
    </v-select>

    <v-btn
      v-if="filtersActive"
      text
      class="primary--text clear-filters-button mr-2"
      @click="clearAllFilters"
    >
      Wyczyść filtry
    </v-btn>

    <v-btn
      depressed
      color="primary"
      :to="{name: 'create-kiw'}"
    >
      Nowy wniosek
    </v-btn>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import props from '@/helpers/componentsProps';
import utils from '@/helpers/utils';
import AppSearchInput from '@/components/UI/AppSearchInput.vue';

export default {
  components: {
    AppSearchInput,
  },

  data() {
    return {
      props,
    };
  },

  computed: {
    ...mapState('filters', [
      'filtersOptions',
      'selectedFilters',
    ]),

    filtersActive() {
      return utils.areFiltersSet(this.selectedFilters, true);
    },

    purposesFiltersLabels() {
      return this.filtersOptions.visualNumberRequestsPurposes.map((p) => ({
          ...p,
          label: p.custom ? 'Inny cel' : p.label,
        }));
    },
  },

  methods: {
    ...mapActions('kiw', [
      'fetchKIW',
    ]),

    ...mapActions('filters', [
      'setFilters',
      'clearFilters',
    ]),

    filterKIW(filter) {
      this.setFilters(filter)
        .then(() => {
          this.fetchKIW();
        });
    },

    selectToggleFilter(filterObject) {
      utils.checkIfFilterExists(filterObject, this.selectedFilters, this.filterKIW);
    },

    clearAllFilters() {
      const { status } = this.selectedFilters;
      this.clearFilters({ status })
        .then(() => {
          this.fetchKIW();
        });
    },
  },

};
</script>

<style lang="scss" scoped>
.kiw-index-toolbar {
  display:flex;
  position:relative;
  &__search {
    width:172px;
    @include desktop {
      width:326px;
    }
  }
}
</style>
